import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tasks-counter"
}
const _hoisted_2 = { class: "tasks-counter__count" }

import { n, t } from '@nextcloud/l10n'
import { computed } from 'vue'
import NcProgressBar from '@nextcloud/vue/components/NcProgressBar'
import { useChatExtrasStore } from '../../stores/chatExtras.ts'


export default /*@__PURE__*/_defineComponent({
  __name: 'TasksCounter',
  setup(__props) {

const chatExtrasStore = useChatExtrasStore()

const tasksCount = computed(() => chatExtrasStore.tasksCount)
const tasksDoneCount = computed(() => chatExtrasStore.tasksDoneCount)

const tasksRatio = computed(() => {
	if (tasksCount.value === 0) {
		return 0
	}
	return (tasksDoneCount.value / tasksCount.value) * 100
})

const tasksSummary = computed(() => {
	if (tasksRatio.value === 100) {
		return t('spreed', 'All tasks done!')
	}
	// TRANSLATORS number of tasks done of total number of tasks
	return n('spreed', '{done} of %n task', '{done} of %n tasks', tasksCount.value, { done: tasksDoneCount.value })
})


return (_ctx: any,_cache: any) => {
  return (tasksCount.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(NcProgressBar), {
          type: "circular",
          value: tasksRatio.value,
          color: tasksRatio.value === 100 ? 'var(--color-border-success)' : undefined
        }, null, 8, ["value", "color"]),
        _createElementVNode("div", _hoisted_2, _toDisplayString(tasksSummary.value), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})